<h2 mat-dialog-title i18n="@@choose-outlet">Choose outlet</h2>
<mat-dialog-content>
    <app-outlet-selection (outletSelected)="onOutletSelect()"></app-outlet-selection>
</mat-dialog-content>
